export const CARD_RARITIES = ["C", "R", "H", "L", "S"] as const;
export type CardRarity = typeof CARD_RARITIES[number];

export const cardSerialTypes = ["C", "R", "H", "L", "S", "PR"] as const;
export type CardSerialType = typeof cardSerialTypes[number];